export const headCopy = {
  head_playground_title:
    "TS Playground - Edytor online dla eksploracji TypeScript oraz JavaScript",
  head_playground_description:
    "Playground pozwala na pisanie TypeScript lub JavaScript online w bezpieczny i udostępnialny sposób.",
  tsconfig_title:
    "Dokumentacja TSConfig - Dokumenty dla każdej opcji TSConfig.",
  tsconfig_description:
    "Od allowJs do useDefineForClassFields dokumentacja TSConfig zawiera informacje o wszystkich aktywnych flagach kompilatora konfigurujących projekt TypeScript.",
  playground_example_prefix: "Przykład Playground - ",

  head_index_title: "Typowany JavaScript w dowolnej skali",
  head_index_description: "Typowany JavaScript w dowolnej skali",
}
